export default {
  list: [],
  listLoading: true,
  listRender: false,
  page: 1,
  startAt: null,
  startAfter: null
}
